module.exports = __webpack_public_path__ + "img/zaymigo.81d34284.svg";